module.exports = __webpack_public_path__ + "img/64.d04a0fba.jpg";